import _ from 'lodash';
import { castToSnapshot, SnapshotOut, types } from 'mobx-state-tree';
import { Mutable, Reduced } from '../types';

export const FreakInfoModel = types.model('FreakInfo', {
  firmwareVersion: types.string,
  firmwareOSVersion: types.string,
  firmwareId: types.string,
});
export type FreakInfo = SnapshotOut<typeof FreakInfoModel>;

const _BTStates = ['disconnected', 'connected', 'connecting'] as const;
export type BTStates = typeof _BTStates;

export const _BluetoothEntryModel = types.model('BluetoothEntry', {
  id: types.string,
  mac: types.maybeNull(types.string),
  name: types.optional(types.string, ''),
  state: types.optional(
    types.enumeration(_BTStates as Mutable<BTStates>),
    'disconnected'
  ),
});
export interface Descriptor {
  uuid: string;
}
interface Characteristic {
  characteristic: string;
  isNotifying: boolean;
  properties: Array<string>;
  service: string;
  value?: object;
  descriptors?: Array<string>;
}
interface _BluetoothEntry {
  advertising?: Record<string, any>;
  characteristics?: Array<Characteristic>;
  services?: Array<string>;
  rssi?: number;
}
export type BluetoothEntry = Reduced<
  SnapshotOut<typeof _BluetoothEntryModel> & _BluetoothEntry
>;

const BluetoothEntryModel = types.snapshotProcessor(_BluetoothEntryModel, {
  // from instance to snapshot
  postProcessor(snapshot): BluetoothEntry {
    const ret = _.cloneDeep(snapshot);
    _.unset(ret, 'state');
    return ret;
  },
});

const _BluetoothInfoModel = types.model('BluetoothInfoModel', {
  info: types.maybeNull(FreakInfoModel),
  entry: types.maybeNull(BluetoothEntryModel),
  autoConnect: types.optional(types.boolean, false),
});
type _BluetoothInfo = SnapshotOut<typeof _BluetoothInfoModel>;

export const BluetoothInfoModel = _BluetoothInfoModel
  .named('BluetoothInfo')
  .actions((self) => ({
    setInfo(inf: FreakInfo | null) {
      if (!_.isEqual(castToSnapshot(self.info), inf)) {
        self.info = inf;
      }
    },
    setEntry(entry: BluetoothEntry | null) {
      // const newEntry = entry && _.pick(entry, ['id', 'name', 'state']);
      if (!_.isEqual(castToSnapshot(self.entry), entry)) {
        const mac = entry?.mac ?? self.entry?.mac;
        self.entry = _.assign(entry, { mac });
      }
    },
  }))
  .actions((self) => ({
    setFrom(obj: _BluetoothInfo) {
      self.setInfo(obj.info);
      self.setEntry(obj.entry);
      self.autoConnect = obj.autoConnect;
    },
  }));

export type BluetoothInfo = SnapshotOut<typeof BluetoothInfoModel>;
